import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import "./CreateDraft.scss";
import ApiContext from "../../../../Api/ApiContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TableList, { TableListHeader, TableListRow } from "../../Components/TableList/TableList";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";
import Tooltip, { ETooltipPosition } from "../../../../Components/Tooltip/TooltipOnRef";
import infoIcon from '../../../../Assets/icons/info-circle.svg'
import SelectType from "../../../../Components/Select/SelectType";
import Loading from "../../../../Components/Loading/Loading";
import NoDataScreen, { ENDSType } from "../../Components/NoDataScreen/NoDataScreen";
import { useDispatch, useSelector } from "react-redux";
import { selectResellerConfig, updateLegalFlyId } from "../../../../Store/configSlice";
import CreditsInsufficient from "../../../../Components/Reseller/CreditsInsufficient/CreditsInsufficient";
import { Paths } from "../../../../Core/EPath";
import { AppDispatch } from "../../../../Store/store";

const CreateDraft = () => {
    const tooltipTargetRef = useRef<HTMLDivElement>(null);

    const [ templates, setTemplates ] = useState([]);
    const [ templateTypes, setTemplateTypes ] = useState([]);
    const [ displayedTemplates, setDisplayedTemplates ] = useState([]);
    const [ documentType, setDocumentType ] = useState("");
    const [ loading, setLoading ] = useState(true);

    const api = useContext(ApiContext);
    const params = useParams();
    const dispatch = useDispatch<AppDispatch>();

    const location = useLocation();

    const getQueryParams = () => {
      return new URLSearchParams(location.search);
    };
  
    const queryParams = getQueryParams();
    const template = queryParams.get('template');

    const resellerConfig = useSelector(selectResellerConfig);

    const { i18n, t } = useTranslation();

    const getTemplates = useCallback(() => {
        api.get('/drafts/templates').then(res => {
            
            setTemplates(res.data.templates);

            let filteredTypes = res.data.templates.filter(template => template.status === "published");
            if (resellerConfig) {
                filteredTypes = filteredTypes.filter(template => {
                    return true;
                    //return resellerConfig.allowedDraftTemplates.includes(template.id);
                })
                setTemplates(
                    res.data.templates.filter(template => {
                        return true;
                        //return resellerConfig.allowedDraftTemplates.includes(template.id);
                    })
                )
            }

            const types = filteredTypes.map(template => {
                return template.type;
            });
            const uniqueTypes = [...new Set(types)];
            setTemplateTypes(uniqueTypes);
            if(!template) {
                setLoading(false);
            }
        });
    }, [api]);

    const navigate = useNavigate();

    const addDraft = useCallback(async (templateId) => {
        setLoading(true);
        api.post('/drafts', { templateId }).then(res => {
            if(isReseller) {
                mapReseller(res.data.draftId);
            }
            navigate(Paths.DRAFT_DETAIL({ id: isReseller ? params.id : res.data.draftId }));
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        if (template && addDraft) {
            console.log("Creating draft from template", template);
            addDraft(template);
        }
    }, [template, addDraft]);

    const isReseller = process.env.REACT_APP_IS_RESELLER === "true";
    const mapReseller = async (documentId) => {
        if (resellerConfig) {
            await api.post('/drafts/map-to-reseller', {
                documentId,
                templateId: parseInt(template),
                resellerDocumentId: params.id
            }).then(() => {
                dispatch(updateLegalFlyId(documentId));
                navigate(Paths.DRAFT_DETAIL({ id: params.id }));
            })
        }
    }

    useEffect(() => {
        const filteredTemplates = templates.filter(template => {
            return (template.type === documentType || documentType === "") && template.status === "published";
        });

        const data = filteredTemplates.map(template => {

            const date = new Date(template.created_at).toLocaleString(i18n.language, {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            });
    
            const row: TableListRow = {
                onClick: () => {addDraft(template.id)}, 
                values: [
                    template.name
            ]};

            if(isReseller) {
                row.values.push(
                    <span className="reseller-credits">1</span>
                );
            } else {
                row.values.push(date);
                row.values.push(<>
                    <img src={template.owner.avatar} alt="avatar" />
                    <span>{template.owner.first_name}</span>
                </>);
            }

            row.values.push("");

            return row;
        });
        setDisplayedTemplates(data);
    }, [documentType, templates]);

    useEffect(() => {
        getTemplates();
    }, [getTemplates]);

    const headers: TableListHeader[] = [
        t('drafting.name')
    ];

    if(isReseller) {
        headers.push(t('draft.credits'));
    } else {
        headers.push(t('drafting.created'));
        headers.push(t('drafting.owner'));
    }

    headers.push("");

    const creditsInsufficient =  useMemo(() => { 
        return resellerConfig && resellerConfig?.credits?.balance < 1;
    }, [resellerConfig]);

    if(loading || template || isReseller) return <Loading />;

    return (
        <div className={"create-draft" + (creditsInsufficient ? " blur" : "")}>
            <h3>{t('drafting.new')}</h3>
            {false && <h5>{t('drafting.type')}</h5>}
            {false && <SelectType type={documentType} setType={setDocumentType} limitedList={templateTypes} barebones />}
            { creditsInsufficient && <CreditsInsufficient amount={resellerConfig.credits?.balance} requiredAmount={1} creditPurchaseUrl={resellerConfig.creditPurchaseUrl} /> }
            <div className="boxes">
                <div className="box">
                    <div className="title">
                        {t('drafting.chooseTemplate')}
                        <div ref={tooltipTargetRef}>
                            <ReactSVG className='info-icon' src={infoIcon} />
                        </div>
                        <Tooltip targetRef={tooltipTargetRef} position={ETooltipPosition.TOP}>
                            <div>{t('drafting.createTooltip')}</div>
                        </Tooltip>
                    </div>
                    <div className="box-content">
                        { displayedTemplates.length === 0 && !resellerConfig ? <NoDataScreen type={ENDSType.NO_TEMPLATE} /> :
                        <div className="select-template">
                            <TableList headers={headers} data={displayedTemplates} />
                        </div> }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateDraft;